<template>
  <div>
    <group-code-add-new
        :is-add-new-group-code-sidebar-active.sync="isAddNewGroupCodeSidebarActive"
        :id = "id"
        :data="groupcodeData"
        @refetch-data="refetchData"
        v-if="ability.can('create','groupcodes')"
    >

    </group-code-add-new>

    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="搜尋..."
              />
              <b-button
                variant="primary"
                @click="handleCreate"
              >
                <span class="text-nowrap">新增集團代碼</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

    <b-table
        ref="refGroupCodeListTable"
        class="position-relative"
        :items="fetchGroupCodes"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
    >
    <template #cell(description)="data">
        <div v-html="data.item.description"></div>
    </template>
    <template #cell(action)="data">
        <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item v-if="ability.can('update','groupcodes')" @click="handleEdit(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
          </b-dropdown>
    </template>
    </b-table>  
    <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalGroupCodes"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>

    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import groupcodeStoreModule from "../groupcodeStoreModule";
import useGroupCodesList from "./useGroupCodesList";
import GroupCodeAddNew from "./GroupCodeListAddNew.vue"

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    GroupCodeAddNew,
  },
  methods:{
      handleCreate(){
          this.id = 0
          this.resetGroupCodeData()
          this.isAddNewGroupCodeSidebarActive = true
      },
      handleEdit(item){
        this.id = item.id
        this.groupcodeData.id = item.id
        this.groupcodeData.group_code = item.group_code
        this.groupcodeData.name_of_group = item.name_of_group
        this.groupcodeData.description = item.description
        this.isAddNewGroupCodeSidebarActive = true
        
      }, resetGroupCodeData(){
        this.groupcodeData = {
            id: 0,
            group_code: '',
            name_of_group: '',
            description: '',
        }
      }
  },
  data(){
    return {
        id:0,
        groupcodeData:{},
    }  
  },
  setup() {
    const CLIENT_GROUP_CODE_STORE_MODULE_NAME = "client-groupcode";

    if (!store.hasModule(CLIENT_GROUP_CODE_STORE_MODULE_NAME))
      store.registerModule(
        CLIENT_GROUP_CODE_STORE_MODULE_NAME,
        groupcodeStoreModule
      );

    onUnmounted(() => {
      if (store.hasModule(CLIENT_GROUP_CODE_STORE_MODULE_NAME))
        store.unregisterModule(CLIENT_GROUP_CODE_STORE_MODULE_NAME);
    });

    const isAddNewGroupCodeSidebarActive = ref(false);

    const {
      fetchGroupCodes,
      tableColumns,
      perPage,
      currentPage,
      totalGroupCodes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refGroupCodeListTable,
      refetchData,
      ability,
    } = useGroupCodesList();

    return {
      //Sidebar
      isAddNewGroupCodeSidebarActive,

      fetchGroupCodes,
      tableColumns,
      perPage,
      currentPage,
      totalGroupCodes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refGroupCodeListTable,
      refetchData,
      avatarText,
      ability,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>